import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
// Services
import { BasketService, DataStoreService } from '../../services';

@Component({
  selector: 'app-checklist',
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.css']
})
export class ChecklistComponent implements OnInit {

  constructor(
    private router: Router,
    private basketService: BasketService,
    private DataStore: DataStoreService,
    private formBuilder: FormBuilder,
    globals: Globals,
  ) {
    this.globals = globals;
  }

  globals: Globals;
  checklistForm: FormGroup;
  submitted = false;
  checklistText;
  checklistTextIrish;
  applicantArray;
  applicationDetails;
  selectedService;
  serviceTotal;
  @ViewChild("error") errorElement: ElementRef;

    linkClicked(ev) {
    if (ev.target.href) {
      console.log(ev.target.href);
      window.open(ev.target.href, '_blank').focus();
      ev.preventDefault();
    }
  }

  ngOnInit() {
    this.checklistForm = this.formBuilder.group({
      checklistCB: [false, Validators.requiredTrue]
    });
    2
    // TODO: we should check details here in dataStore and put them back for ease of use
    if (this.DataStore.selectedLocation) {
      this.applicantArray = this.DataStore.applicantArrayCopy;
      this.selectedService = this.DataStore.selectedService;
      // Add the extra charges to the total cost
      let total = 0;
      this.DataStore.total = 0;
      this.DataStore.passportFeeArray.forEach(extraFee => {
        total = total + extraFee.price;
      });
      this.DataStore.total = this.DataStore.serviceTotal + total
      this.serviceTotal = this.DataStore.serviceTotal;

    } else {
      // Made it a function as back btn uses it too
      this.routerGoBack();
    }
    if (this.DataStore.selectedService) {
      this.checklistText = '';
      this.checklistTextIrish = '';
      const extraQuestions = this.DataStore.selectedService.extra;
      for (const key in extraQuestions) {
        if (extraQuestions.hasOwnProperty(key)) {
          const element = extraQuestions[key];
          if (key.indexOf('checklist_text') >= 0) {
            if (!this.checklistText) {
              this.checklistText += element;
            } else {
              this.checklistText += ' ' + element;
            }
          } else if (key.indexOf('checklist_irish_text') >= 0) {
            if (!this.checklistTextIrish) {
              this.checklistTextIrish += element;
            } else {
              this.checklistTextIrish += ' ' + element;
            }
          }
        }
      }
    }

    this.applicationDetails = this.DataStore.applicationDetails;
    this.selectedService = this.DataStore.service;
    this.serviceTotal = this.applicationDetails ? this.applicationDetails.length * this.selectedService.price : null;
  }

  // Getter for easy access to form fields
  get form() { return this.checklistForm.controls; }

  routerGoBack() {
    // Ensure basket is cleared to stop conflict error
    this.basketService.deleteAllBaskets();
    this.router.navigate(['/application-details']);
  }

  // scroll to the first invalid control on page
  scrollToError() {
    this.errorElement.nativeElement.scrollIntoView({ behavior: 'smooth' });
  }

  proceed() {
    this.submitted = true;

    this.checklistForm.markAllAsTouched();

    if (this.checklistForm.invalid) {
      this.scrollToError();
      return;
    }

    this.router.navigate(['/terms-conditions']);
  }
}
